module.exports = __webpack_public_path__ + "static/media/layersActive.baca9998.png";